<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <div class="note pt-8">
        <div class="d-flex justify-center ">
          <div>
            <v-img v-if="photos.length > 0"
                   height="150"
                   width="266"
                   class="rounded"
                   :src="$downUrl(photos[select].imgAtchFileName)"
            >
              <v-overlay absolute :value="isLoading">
                <v-progress-circular
                    indeterminate
                    size="24"
                />
              </v-overlay>
            </v-img>
          </div>
        </div>
        <div class="d-flex justify-center my-7">
          <v-btn-toggle v-if="ques.length > 0" group v-model="select" active-class="active" class="btn-toggle">
            <v-btn v-for="i in ques.length-1" :key="i" depressed width="48" height="48" :ripple="false"
                   class="mx-2 rounded-pill" :disabled="cmplt">{{ ques[i - 1] }}
            </v-btn>
<!--            <v-file-input class="file-input mx-2" :class="{'active' : select === 4}" accept="image/*" :ripple="false"-->
<!--                          @change="upload" :disabled="cmplt"></v-file-input>-->
          </v-btn-toggle>
        </div>
        <hr class="hr">
        <div class="my-7">
        <Textarea
            :value="textarea"
            :height="200"
            :counter="100"
            :placeholder=replyArr[0]
            @input="textareaVaule"
            :readonly="cmplt"
        />
        </div>
        <div class="d-flex justify-center">
          <v-btn depressed color="primary" min-width="120" class="mx-2 rounded-pill" @click="imgShare">카카오톡 공유</v-btn>
          <v-btn depressed color="primaryLight primary--text" min-width="120" class="mx-2 rounded-pill"
                 @click="imgSave">사진으로 저장
          </v-btn>
        </div>
        <!-- <KakaoShareSheet :sheet="sheet" :photo="photos[select]" :str="value" @sheetClose="sheetClose" @kakaoShare="kakaoShare"/> -->
        <KakaoShareSheet :sheet="sheet" :photo="$downUrl(photos[select].imgAtchFileName)" :str="textarea" :title="title"
                         :btnStr="btnStr"
                         @sheetClose="sheetClose" @kakaoShare="kakaoShare"
                         ref="kakaoShare"/>
        <!-- <Modal :dialog="dialog" str="공유가 완료되었습니다." @close="modalClose"/> -->
      </div>
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import Textarea from '@/components/forms/Textarea'
import KakaoShareSheet from '@/components/layout/bottomSheet/KakaoShareSheet'
// import Camera from '@/components/icons/Camera'
// import Modal from "@/components/layout/modal/Modal";
import utils from '../../../utils/utils.js'
import store from '../../../store'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: true,
    free: 'N',
    cmplt: false,
    sheet: false,
    select: 0,
    dialog: false,
    photos: [],
    ques: [''],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [0],
    userReply: [],
    textarea: '',
    title: "카카오톡 공유",
    btnStr: "공유하기",
    beforeList: [],
    enableList: [],
    file: '',
    fileId: '',
    beforeFileId: '',
    isLoading: false,
  }),
  computed: {},
  components: {
    FooterBtnsNext,
    Textarea,
    KakaoShareSheet,
    // Camera,
    // Modal
  },
  watch: {
    current() {
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.disabledNext = true,
        this.free = 'N',
        this.cmplt = false,
        this.ques = [],
        this.replyArr = [],
        this.replyObjArr = [],
        this.userReplyNo = [0],
        this.userReply = [],
        this.photos = [],
        this.select = 0,
        this.textarea = '',
        this.title = "카카오톡 공유",
        this.btnStr = "공유하기",
        this.beforeList = [],
        this.enableList = [],
        this.file = '',
        this.fileId = '',
        this.beforeFileId = '',
        this.isLoading = false,
        this.getUnitDetailUse()
    }
  },
  mounted() {
    this.getUnitDetailUse();
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      // 초기화
      this.ques.splice(0, this.ques.length)
      this.photos.splice(0, this.photos.length)

      // this.photos

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              this.ques.push(quesEl.ques)

              // 이미지
              // var src = {src:quesEl.imgAtchNo}
              // this.photos.push(src)
              // var src = {src:quesEl.imgAtchNo}
              var src = {imgAtchNo:quesEl.imgAtchNo , imgAtchFileName: quesEl.imgAtchFileName}
              this.photos.push(src)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              if (quesEl.memberUnitDtlReplyList.length > 0) {
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl) => {

                  this.select = i
                  this.userReplyNo[0] = userReplyEl.memberUnitDtlReplyUseNo
                  this.textarea = userReplyEl.reply
                  this.textareaVaule(this.textarea)

                  // 사진업로드 질문답변일때
                  if (i === 4) {
                    this.photos[4].imgAtchNo = userReplyEl.score
                    this.beforeFileId = userReplyEl.score
                  }
                });
              }
            });
          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 서술형 답변
        let replyObj = this.replyObjArr[this.select]
        this.userReply[0] = {
          unitId: replyObj.unitId,
          sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[0],
          // unitUseNo: replyObj.unitUseNo,
          unitNo: replyObj.unitNo,
          // unitDtlUseNo: replyObj.unitDtlUseNo,
          unitDtlNo: replyObj.unitDtlNo,
          // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
          unitDtlQuesNo: replyObj.unitDtlQuesNo,
          // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
          unitDtlReplyNo: replyObj.unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: this.textarea,
          score: this.photos[this.select].imgAtchNo,
          freeYn: this.free
        }

        // 사진이 존재하고 사진 선택으로 저장하지 않을시 삭제
        if (this.select < 4 && this.beforeFileId != '' && this.beforeFileId > 0) {
          this.beforeList.push(this.beforeFileId)
        }

        // 사진으로 저장시 enable
        if (this.fileId != '' && this.fileId > 0 && this.photos[this.select].imgAtchNo == this.fileId) {
          this.enableList.push(this.fileId)
        }

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {

              // 삭제 대상이 있으면 삭제
              if (this.beforeList.length > 0) {
                utils.File.fileDelete(this.beforeList
                ).then(() => {
                  // console.log("삭제 : ", response.data)
                })
                  .catch(async error => {
                    console.log(error)
                  })
                  .finally(() => {
                  })
              }

              // 업로드파일 enable
              if (this.enableList.length > 0) {

                utils.File.fileEnable(this.enableList
                ).then(() => {
                  this.$emit('next')
                })
                  .catch(async error => {
                    console.log(error)
                  })
                  .finally(() => {
                  })
              } else {
                setTimeout(() => this.$emit('next'), 500); // 저장한 이후
              }

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    sheetClose() {
      this.sheet = false;
    },
    cameraCall() {
      this.select = 4;
    },
    kakaoShare(kakaoUrl) {
      if (kakaoUrl != "") {
        this.sendkakao(kakaoUrl)
        this.sheetClose()
      }
    },
    modalClose() {
      this.dialog = false;
      this.$emit('next');
    },
    textareaVaule(value) {
      this.textarea = value;
      if (this.textarea.trim() == "" || this.textarea.length > 100) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    imgShare() {
      this.title = "카카오톡 공유"
      this.btnStr = "공유하기"
      this.sheet = true
    },
    imgSave() {
      this.title = "사진으로 저장"
      this.btnStr = "저장하기"
      this.sheet = true
    },
    sendkakao: function (kakaoUrl) {

      window.Kakao.Share.sendCustom({
        templateId: 88619,
        templateArgs: {
          title: '노트 이미지 공유',
          description: '노트 이미지 공유',
          THU: kakaoUrl
        },
      });
    },
    async upload(file) {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장

        this.isLoading = true

        this.file = file;
        var formData = new FormData();
        formData.append('file', this.file);
        formData.append('beforeFileId', this.beforeFileId);

        utils.File.fileUpload(formData
        ).then(response => {

          if (this.photos[4] != null) {
            this.beforeList.push(this.beforeFileId)
          }

          this.fileId = response.data.fileId
          this.beforeFileId = response.data.fileId

          // this.photos.push(this.fileId)
          this.photos[4] = this.fileId

          // select 초기화
          this.select = 0;

          this.cameraCall()

        })
          .catch(async error => {
            console.log(error)
            this.fileId = 0 // error 로 호출
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.file-input {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
  overflow: hidden;

  .v-input__prepend-outer {
    margin: 0;
  }

  .v-input__control {
    display: none;
  }

  .mdi-paperclip::before {
    content: '';
    display: inline-block;
    width: 48px;
    height: 48px;
    background: url('~@/assets/images/ic_camera2.svg') center center no-repeat;
  }

  &.active {
    .v-icon {
      background: #7260FF !important;
    }

    .mdi-paperclip::before {

      background: url('~@/assets/images/ic_camera2_w.svg') center center no-repeat;
    }
  }
}

::v-deep.v-btn-toggle.btn-toggle {
  button {
    background: var(--v-gray-lighten5) !important;
    color: var(--v-secondary-base) !important;
    opacity: 1 !important;

    &.active {
      background: var(--v-primary-base) !important;
      color: #fff !important;

      svg path {
        fill: #fff !important;
      }
    }
  }
}
</style>
